import { Renderer, Vector2 } from 'three';

export class RayCastMousePositionCalculator {
    public calculate (mouseEvent: MouseEvent, renderer: Renderer): Vector2 {
        const mouse = new Vector2();
        mouse.x = ( (mouseEvent.offsetX) / renderer.domElement.width ) * 2 - 1;
        mouse.y = -( (mouseEvent.offsetY) / renderer.domElement.height ) * 2 + 1;
        return mouse;
    }
}